<!-- @format -->

<div class="card">
	<div class="card__info">
		<h4 [ngClass]="{ selected: isSelected }">
			{{ title }}
		</h4>
		<p *ngIf="dataTypeName" class="datatype">{{ dataTypeName }}</p>
		<p *ngIf="description">{{ description }}</p>
		<div *ngIf="enableDateTime" class="datetime">
			<span style="font-size: 14px">Expires: </span>
			<input type="datetime-local" style="margin-top:15px;border:none; max-width:90%;" *ngIf="enableDateTime" [(ngModel)]="datetime" (ngModelChange)="datetimeChange.emit($event)" [min]="this.minDateTime">
		</div>
	</div>
	<div class="card__checkbox">
		<img
			class="card__checkbox"
			src="../assets/{{ icon }}"
			alt="checkbox"
			(click)="selectIcon()" />
		<div
			cdkDragHandle
			*ngIf="isDraggable">
			<img
				src="../assets/dragger.svg"
				alt="drag icon" />
			<img
				src="../assets/dragger.svg"
				alt="drag icon" />
			<img
				src="../assets/dragger.svg"
				alt="drag icon" />
		</div>
	</div>
</div>
